import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = { multi: Boolean }
  
  connect() {
    const config = {
      create: true,
      sortField: {
        field: "text",
        direction: "asc"
      }
    }
    
    // 如果设置了多选模式
    if (this.multiValue) {
      config.plugins = ['remove_button', 'checkbox_options'];
      config.closeAfterSelect = false;
      config.hidePlaceholder = false;
      config.placeholder = this.element.getAttribute('placeholder') || '请选择...';
    }
    
    new TomSelect(this.element, config);
  }
}
